import { Injectable, inject } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
} from '@angular/common/http';
import { Observable } from 'rxjs';

import { finalize } from 'rxjs/operators';
import { SpinnerService } from '@shared/services/spinner.service';

@Injectable()
export class SpinnerInterceptor implements HttpInterceptor {
  private readonly spinnerSvc = inject(SpinnerService);
  private readonly manualPdfPaths = [
    '/solicitudes/get-solicitud-pdf/',
    '/solicitudes/get-solicitud-pdf-condicional',
    '/reportes-pdf/contratos/',
    '/contract/contratos/get-contrato-pdf-condicional',
  ];
  constructor() {}

  private shouldBypassSpinner(url: string): boolean {
    return this.manualPdfPaths.some((path) => url.includes(path));
  }

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (this.shouldBypassSpinner(request.url)) {
      return next.handle(request);
    }

    this.spinnerSvc.showSpinner();
    return next
      .handle(request)
      .pipe(finalize(() => this.spinnerSvc.hideSpinner()));
  }
}
